/* eslint-disable no-magic-numbers */

import { PaginationState } from "@flexidao/ui-lib";

export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PAGINATION_STATE: PaginationState = {
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
};

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 50, 100];
